import React from 'react';
import SettingsProfileForm from '../forms/SettingsProfileForm';
import {UploadedFile} from '../forms/FileUpload.js';

import CurrentUserActions from '../actions/CurrentUserActions';
import LoadingView from '../components/LoadingView';


class SettingsProfile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedLogoSrc: "",
            settingsSaved: false,
            isLoading: false
        }
    }

    componentWillReceiveProps(nextProps) {
        const saveError = nextProps.saveError;

        if (nextProps.user.settingsSaved !== this.state.settingsSaved) {
            this.setState({settingsSaved: nextProps.user.settingsSaved, isLoading: false});
        }

        if (Object.keys(saveError).length && saveError.errors && Object.keys(saveError.errors).length) {
            this.setState({isLoading: false});
        }
    }

    prepareData(user) {
        const profile_picture = user.profile.profile_picture;
        if (profile_picture) {
            user.profile_picture = new UploadedFile(profile_picture.fileName, profile_picture.dataUri, profile_picture.mimeType, profile_picture.size);
        }
        user.phone = user.profile.phone;
        user.website = user.profile.website;
        return user;
    }

    saveSettings() {
        const data = this.refs.profileForm.getValue();
        if (data) {
            this.setState({isLoading: true});

            let user_data = {...data};
            if (user_data.website && user_data.website.indexOf('://') < 0) {
                user_data.website = "http://" + user_data.website;
            }

            CurrentUserActions.updateUser(user_data);
        }
    }

    getSaveButton(company) {
        let button = <button onClick={this.saveSettings.bind(this)} className="btn btn-small btn-green">Save settings</button>;
        if (this.state.isLoading) {
            button = <button className="btn btn-small btn-green"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></button>;
        }
        return button;
    }

    render () {
        const user = this.props.user.profile;
        const settingsSaved = this.state.settingsSaved;

        if (!this.props.user.userDataReceived) {
            return (
                <LoadingView />
            );
        }

        return (
            <div className={"settings-profile" + (this.props.isActive ? " active" : "")}>
                <SettingsProfileForm ref="profileForm" initialFormData={this.prepareData(user)} errors={this.props.saveError} />
                <div className="tab-section">
                    {this.getSaveButton()}
                    <p className={"data-info " + (settingsSaved ? "saved" : "")}>Settings saved!</p>
                </div>
            </div>
        );
    }
}

export default SettingsProfile;



/** WEBPACK FOOTER **
 ** ./app/src/components/SettingsProfile.js
 **/